// extracted by mini-css-extract-plugin
export default {"Footer":"Layout_Footer__RdbCr","root":"Layout_root__uvdC6","root_wrapper":"Layout_root_wrapper__mTe-+"};